import { withActionDialogLock } from "@/action-dialog/actionDialogLock";
import { CopyToWorkspaceCallable } from "@/action-dialog/callables";
import type { FileRecord } from "@cohesive/api-client";

export interface CopyToWorkspaceParams {
  record: FileRecord;
}

export function runCopyToWorkspaceWorkflow(
  params: CopyToWorkspaceParams,
): Promise<boolean> {
  return withActionDialogLock(() =>
    CopyToWorkspaceCallable.call({ record: params.record }),
  );
}
